import { z } from "zod";

export type MemberLimit = z.infer<typeof MemberLimitSchema>;
export const MemberLimitSchema = z.object({
  current: z.number(),
  limit: z.number(),
});
